import { Socket } from 'socket.io-client'
import { v4 as uuidv4 } from 'uuid'

const sendMessage = (
  socket: Socket,
  {
    channelId,
    content,
    currentUserId,
  }: { channelId: string; content: string; currentUserId: string },
) => {
  const newMessage: Api_Chat.ChatMessage = {
    id: uuidv4(),
    channelId,
    type: 'text' as const,
    content: { text: content },
    createdAt: new Date().toJSON(),
    createdBy: currentUserId,
  }
  return [
    newMessage,
    new Promise<Api_Chat.ChatMessage | null>((resolve, reject) => {
      socket.emit(
        'message',
        {
          channelType: 'support',
          message: newMessage,
        },
        (ack: any) => {
          if (!ack) {
            reject()
          } else {
            resolve(ack as Api_Chat.ChatMessage | null)
          }
        },
      )
    }),
  ] as const
}

export const ChatMessagingService = { sendMessage }
